import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Menu, MenuItem, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

/**
 * Compact hamburger navigation shown to anonymous visitors on small screens,
 * mirroring the links available in LandingNavLinks.
 */
export default function LandingMobileNav() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const close = () => setAnchorEl(null);
  const go = (path: string) => {
    close();
    navigate(path);
  };

  return (
    <>
      <IconButton
        size="large"
        aria-label="open navigation menu"
        aria-controls="landing-mobile-menu"
        aria-haspopup="true"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="landing-mobile-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
      >
        <MenuItem onClick={() => go('/features-pricing')}>
          Features & Pricing
        </MenuItem>
        <MenuItem onClick={() => go('/find-barbers')}>Find a Barber</MenuItem>
        <Divider />
        <MenuItem onClick={() => go('/user-login')}>Login</MenuItem>
        <MenuItem onClick={() => go('/get-started')}>
          <strong>Get Started</strong>
        </MenuItem>
      </Menu>
    </>
  );
}
